export enum PositionEnum {
	Doctor = 'Doctor',
	Employee = 'Employee',
	Therapist = 'Therapist',
}
